<template>
  <ts-card>
    <div
      class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
    >
      <h4 class="ts-text-sm">{{ $t('preInvoice.filterByDate') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <div class="row form-group">
        <div class="col-md-12">
          <ts-date-picker-input v-model="date_from" />
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-12">
          <ts-date-picker-input v-model="date_to" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-right">
          <ts-button @click="$emit('close')">{{ $t('close') }}</ts-button>
        </div>
      </div>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
export default {
  name: 'filterDatePreInvoice',
  data() {
    return {}
  },
  computed: {
    date_from: {
      get() {
        return this.$store.state.preInvoice.date_from
      },
      set(val) {
        this.$store.commit('preInvoice/SET_DATE_FROM', val)
      }
    },
    date_to: {
      get() {
        return this.$store.state.preInvoice.date_to
      },
      set(val) {
        this.$store.commit('preInvoice/SET_DATE_TO', val)
      }
    }
  }
}
</script>
